export function chatIndex(data) {
  const used=new Map(),ignored=new Set(),names=new Map();
  for(const agent of data.agents||[]) {const id=agent.target?.target_username;if(id)used.set(id,[...(used.get(id)||[]),agent]);}
  for(const item of data.discoveries||[])if(item.state==='ignored')ignored.add(item.chat_username);
  for(const chat of data.sessions||[])names.set(chat.chat_name,(names.get(chat.chat_name)||0)+1);
  return {used,ignored,names};
}
export function visibleChats(data,{filter='unassigned',search='',type='group'}={}) {
  const {used,ignored}=chatIndex(data),query=search.trim().toLocaleLowerCase('de-DE');
  return (data.sessions||[]).filter(chat=>(type==='all'||chat.chat_type===type)&&
    (filter==='all'||(filter==='ignored'?ignored.has(chat.chat_username):!ignored.has(chat.chat_username)&&!used.has(chat.chat_username)))&&
    `${chat.chat_name} ${chat.chat_username}`.toLocaleLowerCase('de-DE').includes(query));
}
export function visibleSuggestions(agent,data) {
  const {ignored}=chatIndex(data),sessions=new Map((data.sessions||[]).map(chat=>[chat.chat_username,chat]));
  return (agent.suggestions||[]).filter(chat=>!ignored.has(chat.chat_username)&&sessions.has(chat.chat_username))
    .map(chat=>({...chat,...sessions.get(chat.chat_username)}));
}
